import React from 'react';
import PropTypes from 'prop-types';

export function TitleCell(props) {
  return (
    <th className={props.className}>
      <p>{props.text}</p>
    </th>
  );
}

TitleCell.propTypes = {
  /**
   * Text to be displayed on the cell
   */
  text: PropTypes.string,
  /**
   * className to be set on the cell
   */
  className: PropTypes.string,
};
